<iw-shared-layout-container-authentication #auth>
  <div class="columns is-tablet container-login">
    <div class="column is-8 has-background-white">
      <section class="section logo pb-2">
        <img *ngIf="auth.isDicom()" ngSrc="./assets/design/logo-gesoft.jpg" height="47" width="200"/>
        <img *ngIf="!auth.isDicom()" src="./assets/design/iw_logo.svg" class="mt-2" style="color:#000; max-height: 20px;"/>
      </section>
      <section class="section pt-0 is-flex is-relative" style="flex-flow: column; height: calc(100% - 80px);">
        <iw-shared-login (onValidationSuccess)="setLogin($event)" [formHandler]="formHandler"></iw-shared-login>
        <div class="notification is-warning is-light mt-4 is-size-7 p-2">
          Falls Sie noch unser altes Shopsystem verwenden, finden Sie <a href="https://drinks.v2.indenware.de/" style="color:inherit">hier</a> den Zugang.
        </div>
        <div>
          <a class="is-pulled-right" routerLink="/password-lost">Passwort vergessen?</a>
        </div>
      </section>
    </div>
    <div class="column is-4 contact">
      <p class="text-a has-text-white m-5">
            <span *ngIf="auth.isDicom()">
               <b>Fragen?</b><br><br>
            +49 (0)7633 / 95 20 70<br>
            service&#64;dicom-software.de<br><br>



            DICOM Dischinger Computer GmbH<br>
            Im Ebnet 6<br>
            79238 Ehrenkirchen<br>
            </span>
        <span *ngIf="!auth.isDicom()">
                  <b>Fragen?</b><br><br>
           +49 (0)2771 / 87999 50<br>
            info&#64;indenware.de<br><br>
            IndenWare GmbH<br>
            Driedorfstr. 13<br>
            35683 Dillenburg
            </span>
      </p>
    </div>
  </div>
</iw-shared-layout-container-authentication>
